import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content"
}
const _hoisted_2 = { class: "_flexwrap _my-6" }
const _hoisted_3 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_4 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_5 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_6 = { class: "gfu-1of2 gfu-1of4--l _flexcol _pa-2" }
const _hoisted_7 = { class: "_flexwrap _ai-c" }
const _hoisted_8 = { class: "gfu-1of1 gfu-3of4--m _pa-3 _tac _tal--l" }
const _hoisted_9 = { class: "gfu-hd gfu-hd--h3" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "gfu-1of1 gfu-1of4--m _tac _pa-3" }
const _hoisted_12 = { class: "gfu-hd gfu-hd--h2 _tc--accent" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "_tac" }
const _hoisted_15 = {
  key: 1,
  class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content"
}
const _hoisted_16 = { class: "gfu-bt gfu-bt--b1" }
const _hoisted_17 = { class: "gfu-box gfu-box--flat gfu-box--huge _my-6" }
const _hoisted_18 = { class: "_flexwrap _ai-c" }
const _hoisted_19 = { class: "gfu-1of1 gfu-3of4--m _pa-3" }
const _hoisted_20 = { class: "gfu-bt gfu-bt--b1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_button = _resolveComponent("base-button")
  const _component_box = _resolveComponent("box")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.FeesLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "gfu-info-hero gfu-info-hero--fees _jc-c" }, [
        _createElementVNode("div", { class: "gfu-info-hero__cover" }),
        _createElementVNode("div", { class: "gfu-info-hero__content" }, [
          _createElementVNode("h2", { class: "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4" }, "Fees"),
          _createTextVNode(" Easily fund and manage your campaign. Exclusive features at no extra cost. ")
        ])
      ], -1 /* CACHED */)),
      ($options.isExternalPMV2Enabled)
        ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
            _createVNode(_component_box, {
              class: "_tac _mb-6",
              main: true,
              huge: true
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, [
                  _createTextVNode("Exclusive benefits "),
                  _createElementVNode("span", { class: "_fw-n" }, "for your project.")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_tooltip, { text: "Widest selection of payment options on the crowdfunding market" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          name: "money-bill-wave",
                          size: "2x",
                          class: "_tc--accent"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, [
                      _createTextVNode("Various payment "),
                      _createElementVNode("br"),
                      _createTextVNode("methods")
                    ], -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_base_image, {
                      src: "/content/images/static/stretch-pay/stretch-pay-icon.svg",
                      height: "42",
                      width: "42",
                      alt: "stretchPay",
                      class: "_mx-a"
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Stretch Pay", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_tooltip, { text: "Free promotion of your project on our site: main page, newsletter, and more" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          name: "users",
                          size: "2x",
                          class: "_tc--accent"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "Huge community", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_tooltip, { text: "If you are based outside of the EU, we will handle tax settlement for the B2C orders placed by EU backers for you " }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          name: "scale-balanced",
                          size: "2x",
                          class: "_tc--accent"
                        }),
                        _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h4 _mt-2" }, "VAT handling", -1 /* CACHED */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _createVNode(_component_base_button, {
                  tag: "a",
                  href: $options.becomeACreatorUrl
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Learn more", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ]),
              _: 1 /* STABLE */
            }),
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "Our offer", -1 /* CACHED */)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, "Complex crowdfunding and pledge manager services depending on your needs. No hidden fees.", -1 /* CACHED */)),
            _createVNode(_component_box, {
              class: "_my-6",
              main: true,
              huge: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.title
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }, null, -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h4", _hoisted_9, _toDisplayString(item.title), 1 /* TEXT */),
                        _createElementVNode("div", {
                          class: "gfu-bt gfu-bt--b1",
                          innerHTML: item.description
                        }, null, 8 /* PROPS */, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h4", _hoisted_12, _toDisplayString(item.value), 1 /* TEXT */),
                        (item.valueDescription)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.valueDescription), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light _mb-6" }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_base_button, {
                    tag: "a",
                    href: $options.launchYourProjectUrl
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Launch your project", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"])
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (_openBlock(), _createElementBlock("main", _hoisted_15, [
            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h2" }, "Competitive pricing", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_16, _toDisplayString($options.platformName) + " offers complex crowdfunding and pledge manager services depending on your needs.", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_17, [
              _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h3 _mb-3" }, "Crowdfunding", -1 /* CACHED */)),
              _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3" }, "Platform fee", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_20, " Our commission - how much we take from the raised amount (only if your project is funded). Pledge managers for campaigns run on " + _toDisplayString($options.platformName) + " are free. ", 1 /* TEXT */)
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "gfu-1of1 gfu-1of4--m _tac _pa-3" }, [
                  _createElementVNode("div", { class: "_mb-3" }, [
                    _createElementVNode("h4", { class: "gfu-hd gfu-hd--h2" }, "5%"),
                    _createElementVNode("div", null, "in crowdfunding and late pledge")
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", { class: "gfu-hd gfu-hd--h2" }, "0%"),
                    _createElementVNode("div", null, "in pledge manager")
                  ])
                ], -1 /* CACHED */))
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }, null, -1 /* CACHED */)),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "_flexwrap _ai-c" }, [
                _createElementVNode("div", { class: "gfu-1of1 gfu-3of4--m _pa-3" }, [
                  _createElementVNode("h4", { class: "gfu-hd gfu-hd--h3" }, "Payment processing"),
                  _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " The fee applies to every transaction + fixed fee in the project currency (e.g. $0.2 when $ is the project currency). ")
                ]),
                _createElementVNode("div", { class: "gfu-1of1 gfu-1of4--m _tac _pa-3" }, [
                  _createElementVNode("div", { class: "_mb-3" }, [
                    _createElementVNode("h4", { class: "gfu-hd gfu-hd--h2" }, "3%"),
                    _createElementVNode("div", null, "+0.2 per transaction")
                  ])
                ])
              ], -1 /* CACHED */)),
              _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }, null, -1 /* CACHED */))
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "gfu-box gfu-box--flat gfu-box--huge" }, [
              _createElementVNode("h3", { class: "gfu-hd gfu-hd--h3 _mb-3" }, "Pledge manager for external platforms"),
              _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " Managing pledges (changing rewards, collecting shipping address, late pledges, etc.) is free. Payment processing fee depends on your individual agreement with the payment operator (Stripe/PayPal). "),
              _createElementVNode("hr", { class: "gfu-hr gfu-hr--light" }),
              _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, " Additionally, we'll appreciate sending us 1-2 copies of your game. We're working on our board game collection! ")
            ], -1 /* CACHED */))
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}